import React, { Fragment, useContext, useEffect, useState } from 'react';
import { Col, Card, CardHeader, Table, Form, FormGroup, Label, Input, ModalFooter, Row } from 'reactstrap';
import { Btn } from '../../AbstractElements';
import { useDispatch, useSelector } from 'react-redux';
import CommonModal from '../../Components/Modals/modal';
import Pagination from '../../Components/Pagination/Pagination';
import Empty from '../../Components/Empty/Index';
import SweetAlert from 'sweetalert2';
import { getCategory, } from '../../store/categorySlice';

import { getGkShorts, ModalToggle, isOpenModal, addGkShorts, editGkShorts, statusDeleteGkShorts, } from '../../store/gkShortsSlice';


const GKShortsTable = () => {
  const storeVar = useSelector(state => state.gkShorts)
  const categoryVar = useSelector(state => state.category)
  const dispatch = useDispatch();
  const toggle = () => dispatch(ModalToggle());
  const [submit, setSubmit] = useState(false);
  const [formVar, setFormVar] = useState({
    keyword: '',
    limit: 10,
    offset: 0,
    currentPage: 1,
    status: 'active',
    modalTitle: null,
    editState: false,
    categoryId: '',
    title: '',
    description: '',
    shotsId: "",
    videoUrl: '',
  });

  useEffect(() => {
    dispatch(getGkShorts(formVar.limit, formVar.offset,))
    dispatch(getCategory(100, 0, 'active', ''))

  }, []);

  const pageChange = (page) => {
    const offset = formVar.limit * (page - 1)
    setFormVar((prevFormVar) => ({
      ...prevFormVar,
      currentPage: page,
      offset: offset
    }))
    dispatch(getGkShorts(formVar.limit, offset,))
  };
  const AddToggleModal = () => {
    setSubmit(false)
    dispatch(isOpenModal(true))
    setFormVar((prevFormVar) => ({
      ...prevFormVar,
      editState: false,
      modalTitle: 'Add GK Shorts',
      title: '',
      description: '',
      categoryId: '',
      videoUrl: ''
    }))
  }
  const EditToggleModal = (item) => {
    setSubmit(false)
    dispatch(isOpenModal(true))
    setFormVar((prevFormVar) => ({
      ...prevFormVar,
      editState: true,
      modalTitle: 'Edit GK Shorts',
      title: item.title || '',
      description: item.description || '',
      categoryId: item.categoryId || '',
      videoUrl: item.videoUrl || '',
      shotsId: item._id,
    }))
  }
  const submitMenu = () => {
    if (titleValid() || categoryIdValid() || (!formVar.editState && videoUrlValid())) {
      setSubmit(true)
      return null
    }
    setSubmit(false)
    if (formVar.editState) {
      dispatch(editGkShorts(formVar.shotsId, {
        title: formVar.title,
        description: formVar.description,
        categoryId: formVar.categoryId,
        videoUrl: formVar.videoUrl,
      }))
    } else {
      dispatch(addGkShorts(formVar.title, formVar.categoryId, formVar.videoUrl, formVar.description))
    }
  }

  const titleValid = () => {
    if (!formVar.title) {
      return "Title is required";
    }
  }
  const categoryIdValid = () => {
    if (!formVar.categoryId) {
      return "Exam Series is required";
    }
  }
  const videoUrlValid = () => {
    if (!formVar.videoUrl) {
      return "Video URL is required";
    }
  }


  const DeleteModel = (data) => {
    SweetAlert.fire({
      title: 'Are you sure?',
      text: 'Once deleted, you will not be able to recover this imaginary file!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Ok',
      cancelButtonText: 'Cancel',
      reverseButtons: true
    })
      .then((result) => {
        if (result.value) {
          dispatch(statusDeleteGkShorts(data._id))
        }
      });
  }

  const handleChangeStatus = ({ meta, file }, status) => {
    if (status === 'done') {
      const reader = new FileReader();
      reader.onload = (e) => {
        setFormVar((prevFormVar) => ({
          ...prevFormVar,
          bannerImageURL: e.target.result,
        }))
      };
      reader.readAsDataURL(file);
      setFormVar((prevFormVar) => ({
        ...prevFormVar,
        bannerFile: file,
      }))
    } else if (status === "removed") {
      setFormVar((prevFormVar) => ({
        ...prevFormVar,
        bannerFile: null,
        bannerImageURL: null,
      }))
    }
  };



  return (
    <Fragment>
      <Col sm='12'>
        <Card>
          <CardHeader>
            <Row>
              <Col md="6">
              </Col>
              <Col md="4">
              </Col>
              <Col md="2" className='d-flex justify-content-end align-items-center'>
                <div className="text-end border-2 w-100">
                  <Btn attrBtn={{ color: 'info-gradien', className: 'w-100', size: 'sm', onClick: AddToggleModal }}>
                    Add Shorts
                  </Btn>
                </div>
              </Col>
            </Row>

          </CardHeader>
          <div className='table-responsive'>
            <Table hover={true} className='table-border-horizontal table-light'>
              <thead>
                <tr>
                  <th scope='col'>Sl.No</th>
                  <th scope='col'>Title</th>
                  <th scope='col'>Status</th>
                  <th scope='col'>Action</th>
                </tr>
              </thead>
              <tbody>
                {storeVar.gkShortsData?.map((item, index) => (
                  <tr key={index}>
                    <th scope='row'>{index + 1}</th>
                    <td >{item.title}</td>
                    <td>
                      {
                        item.status === 'active' && <>
                          <span className={`font-success rounded-1 p-1 me-2 d-flex align-items-center`}>
                            <i className="fa fa-check-circle-o fa-lg" aria-hidden="true"></i>
                            &nbsp; <span>Active</span>
                          </span>
                        </>
                      }

                      {
                        item.status === 'processing' && <>
                          <span className={`font-warning w-50 rounded-1 p-1 me-2 d-flex align-items-center`}>
                            <i className="fa fa-times-circle-o fa-lg" aria-hidden="true"></i>
                            &nbsp; <span>{item.status}</span>
                          </span>
                        </>
                      }
                    </td>
                    <td>
                      <div className='d-flex gap-2 align-items-center'>
                        <div className='cursor-pointer bg-light-primary font-primary action-icon'>
                          <i className="fa fa-edit fa-lg" onClick={(e) => EditToggleModal(item)}></i>
                          <div className="tooltipCustom">Edit</div>
                        </div>
                        <div className='cursor-pointer bg-light-info font-danger action-icon'>
                          <i className="fa fa-trash fa-lg" onClick={(e) => DeleteModel(item)}></i>
                          <div className="tooltipCustom">Delete</div>
                        </div>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
          {
            storeVar.totalGkShorts <= 0 && (
              <Empty />
            )
          }
        </Card>
        {
          storeVar.totalGkShorts > 0 &&
          <Pagination currentPage={formVar.currentPage} totalItem={storeVar.totalGkShorts}
            itemsPerPage={formVar.limit} showEllipsisAfter={true} visiblePageCount={3} onPageChange={pageChange} />
        }
      </Col>
      <CommonModal isOpen={storeVar.isOpenModal} title={formVar.modalTitle} toggler={toggle} >
        <Form>
          <FormGroup>
            <Label className="col-form-label" for="recipient-name">Title</Label>
            <Input className="form-control" type="text" placeholder='Enter GK Shorts Title' onChange={(e) => setFormVar((prevFormVar) => ({ ...prevFormVar, title: e.target.value }))} value={formVar.title} />
            {submit && titleValid() ? <span className='d-block font-danger'>{titleValid()}</span> : ""}
            <Label className="col-form-label" for="recipient-name">Exam Series</Label>
            <select className="form-control form-control-inverse " name="select" type="select"
              value={formVar.categoryId} onChange={(e) => setFormVar((prevFormVar) => ({ ...prevFormVar, categoryId: e.target.value }))}>
              <option value="" >Select Exam Series</option>
              {categoryVar?.categoryData?.map((item, index) => (
                <option key={index} value={item._id}>{item.name}</option>
              ))}
            </select>
            {submit && categoryIdValid() ? <span className='d-block font-danger'>{categoryIdValid()}</span> : ""}
            {!formVar.editState &&
              <>
                <Label className="col-form-label" for="recipient-name">Video URL</Label>
                <Input 
                  className="form-control" 
                  type="text" 
                  placeholder='Enter Video URL (e.g. https://www.youtube.com/watch?v=...)' 
                  onChange={(e) => setFormVar((prevFormVar) => ({ ...prevFormVar, videoUrl: e.target.value }))} 
                  value={formVar.videoUrl} 
                />
                {submit && videoUrlValid() ? <span className='d-block font-danger'>{videoUrlValid()}</span> : ""}
              </>
            }
            {formVar.editState &&
              <>
                <Label className="col-form-label" for="recipient-name">Video URL</Label>
                <Input 
                  className="form-control" 
                  type="text" 
                  placeholder='Enter Video URL' 
                  onChange={(e) => setFormVar((prevFormVar) => ({ ...prevFormVar, videoUrl: e.target.value }))} 
                  value={formVar.videoUrl} 
                />
              </>
            }
            <Label className="col-form-label" for="recipient-name">Description <small className="text-muted">(Optional)</small></Label>
            <Input className="form-control" type="textarea" rows="3" placeholder='Enter description (optional)' onChange={(e) => setFormVar((prevFormVar) => ({ ...prevFormVar, description: e.target.value }))} value={formVar.description} />
          </FormGroup>
        </Form>
        <ModalFooter>
          <Btn attrBtn={{ color: 'secondary', onClick: toggle }} >Close</Btn>
          <Btn attrBtn={{ color: 'primary', onClick: submitMenu }}>Save Changes</Btn>
        </ModalFooter>
      </CommonModal>


    </Fragment>
  );
};

export default GKShortsTable;
